<template lang="pug">
.features.features-home.features-coins
  .columns
    .column.is-three-quarters.position-relative
      .control.is-medium.is-expanded.has-icons-right
        input.input.is-medium#local-coin-search(
          type="text" 
          placeholder='Search for answers', 
          v-model='search'
          ref='inputsearch'
          v-on:input="debounceInput"
          @keyup.enter="debounceInput"
        )
        span.icon.is-small.is-right
          i.fa.fa-search

      .is-flex.top-article-container
        nav.breadcrumb.flex-1(v-if="type")
          ul
            li
              a(href="/support") All
            template(v-if="article && article.categorySlug")
              li
                a(:href="'/support/category/' + article.categorySlug" ) {{ article.categoryTitle }}

        div.has-text-right.fs-13(v-if="article && article.updated_at && !isLoading")
          div.text-white-on-dark Last updated: {{ article.updated_at | fromNow }}
          div.text-white-on-dark Posted on: {{ article.created_at | formatFullDate }}

      div.category-container(:class="{'is-loading': isLoading}")
        div.has-text-left(v-for="o in categories")
          .category(:style="'top: ' + topWarningMessage + 'px;'")
            a.flex-1(:href="'/support/category/' + o.slug", v-if="type !== 'category'") {{ o.title }}
            span.flex-1(v-else) {{ o.title }}
            a.article-count(:href="'/support/category/' + o.slug", v-if="type !== 'category' && !search")
              span.fs-12 View all {{ o.count }} articles
          .articles-container.column
            .articles(v-if="!isLoading && search && o.articles.length === 0")
              span No articles coincide with your search
            .articles.columns
              a.article-mini(v-for="a in o.articles", :href="'/support/article/' + a.slug")
                .article-inner
                  .article-title
                    span {{ a.title }}
                  .article-content
                    span {{ a.shortText }}
                    .is-flex.aic
                      div.continue-reading.flex-1
                        a Continue reading
                      div.continue-reading.fs-11(v-if="o.show_posted_date")
                        span Posted on {{ a.created_at | formatDateSecond }}
            .has-text-centered        
              a.article-count(:href="'/support/category/' + o.slug", v-if="type !== 'category' && !search")
                span.fs-12 View all {{ o.count }} articles

      .full-article(v-if="type === 'article' && !isLoading && article && article.html")
        div(v-html="article.html")

      .articles(v-if="type === 'article' && noData")
        span Article not found
      .articles(v-if="type === 'category' && noData")
        span Category not found

    .column.is-one-quarter.has-text-left.contact-support.right-column
      .right-column-container(:style="'top: ' + (topWarningMessage + 20) + 'px;'")
        p.text-white-on-dark If you have any issue, question or suggestion contact us here:
        br
        .mb-10
          div Email (Official Support Channel)
          a.social-link(href='mailto:support@unmineable.com')
            b support@unmineable.com
        .mb-10
          div X (formerly Twitter)
          a.social-link(href='https://x.com/un_mineable', target='_blank')
            b @un_mineable
        .mb-10
          div Instagram
          a.social-link(href='https://instagram.com/unminable', target='_blank')
            b @unminable
        .mt-15
          span Beware of impersonators, we have no official Telegram or Discord channels.

        //- .support-suggestion
        //-   a(href='#', @click.stop="showSuggestionContentTextArea") Do you think there is a missing article or information?
        //-   .suggestion-content(v-if="showSuggestionContent")
        //-     textarea.textarea(v-model="suggestionMessage", ref="textareasuggestion")
        //-     .has-text-right
        //-       button.button.is-normal.is-success(
        //-         :disabled="isSendingSuggestion"
        //-         :class="{'is-loading': isSendingSuggestion}"
        //-         @click="sendSuggestion"
        //-       ) Send suggestion

        //- menu-mini.mt-10
        br
        .back-to-top.button.is-small(@click="backToTop")
          span.icon.is-small
            i.fa.fa-angle-up
          span Back to top
        br
        br
</template>

<script>
import { apiGetSupport, debounce } from '../util/general'
export default {
  name: 'view_support',
  data() {
    return {
      isLoading: true,
      type: '',
      slug: '',
      search: '',
      categories: [],
      noData: false,
      article: {},
      // isSendingSuggestion   : false,
      // showSuggestionContent : false,
      // suggestionMessage     : '',
      topWarningMessage: 0
    }
  },
  created() {
    let vm = this
    vm.$store.dispatch('setPageSelected', 'support')
    vm.search = vm.$route.query.search
    vm.type = vm.$route.params.type
    vm.slug = vm.$route.params.slug
    vm.fetch()
    vm.updateMetaTags()
    vm.$store.dispatch('validateVersion')
  },
  mounted() {
    let vm = this
    if (window.innerWidth > 420) vm.$refs.inputsearch.focus()
    window.addEventListener('resize', vm.assignTopWarningMessage);
    vm.$nextTick(() => {
      vm.assignTopWarningMessage()
    })
  },
  unmounted() {
    let vm = this
    window.addEventListener('resize', vm.assignTopWarningMessage);
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.search = this.search.trim()
      this.$router.push('/support?search=' + this.search)
      this.type = ''
      this.slug = ''
      this.fetch()
    }, 500),
    updateMetaTags() {
      let vm = this
      let title = 'unMineable Support Center - Earn your favorite crypto coins!'
      if (vm.type === 'article' && vm.article && vm.article.title) title = 'unMineable Support Center - ' + vm.article.title
      if (vm.type === 'category' && vm.categories && vm.categories[0] && vm.categories[0].title) title = 'unMineable Support Center - ' + vm.categories[0].title
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    },
    fetch() {
      var vm = this
      vm.isLoading = true
      vm.noData = false
      var url = '/support'
      if (vm.type && !vm.search) url += `/${vm.type}/${vm.slug}`
      var obj = {}
      if (vm.search) obj.search = vm.search
      apiGetSupport(vm, url, obj, function (data) {
        if (data.success) {
          vm.categories = data.data.categories
          vm.article = data.data.article
          vm.noData = data.data.noData
          vm.updateMetaTags()
        } else {
          if (data.code === 404) {
            vm.goTo('/support')
          } else {
            vm.$store.dispatch('notifyError', data.msg)
          }
        }
      }, function (err) {
        console.error(err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
      })
    },
    // showSuggestionContentTextArea () {
    //   let vm = this
    //   vm.showSuggestionContent = true
    //   vm.$nextTick(() => {
    //     vm.$refs.textareasuggestion.focus()
    //   })
    // },
    // sendSuggestion () {
    //   var vm = this

    //   vm.suggestionMessage = vm.suggestionMessage.trim()
    //   if (!vm.suggestionMessage) return

    //   vm.isSendingSuggestion = true
    //   var url = '/support'
    //   var obj = {
    //     message: vm.suggestionMessage
    //   }
    //   apiPostSupport(vm, url, obj, function (data) {
    //     if (data.success) {
    //       vm.$store.dispatch('notifySuccess', 'Suggestion succesfully sent')
    //       vm.showSuggestionContent = false
    //       vm.suggestionMessage = ''
    //     } else {
    //       vm.$store.dispatch('notifyError')
    //     }
    //   }, function (err) {
    //     console.error('Error:', err.message)
    //     vm.$store.dispatch('notifyError', err.message)
    //   }, function () {
    //     vm.isSendingSuggestion = false
    //   })
    // },
    assignTopWarningMessage() {
      let vm = this
      vm.topWarningMessage = document.querySelector('.warning-banner') ? document.querySelector('.warning-banner').clientHeight || 0 : 0
    },
    backToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    goTo(path) {
      let vm = this
      vm.$router.push(path)
      vm.$router.go()
      // window.location.reload()
    }
  }
}
</script>

<style lang="stylus" scoped>
.position-relative
  position relative
.category
  display flex
  border-bottom 1px solid #ccc
  align-items: center;
  padding-top 10px
  padding-bottom 10px
  position sticky
  background #fff
  z-index 1
  a
    &:hover
      color: #000000
  .flex-1
    font-weight 700
    color #4a4a4a
    color #4a4a4a
    font-size 27px
    flex 1
  .article-count
    color #4a4a4a
    font-size 13px
.articles
  flex-wrap wrap
  
  .article-mini
    cursor pointer
    color #4a4a4a
    padding 5px
    width 100%
    .article-inner
      border-radius 5px
      border 1px solid #ccc
      padding 15px
      display block
      &:hover
        border solid 1px #8e8e8e
    .article-title
      span
        font-weight 400
    .article-content
      font-size: 12px;
      text-align: justify;
    .article-bottom
      font-size 13px
.bottom
  text-align right
  font-size 13px

.articles-container
  position relative
  margin-top: 10px;


.category-container.is-loading
  &:after
    content: "Loading...";
    text-align: center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0px;
    color: #000;
    height: 100%;
    background: rgba(255,255,255,0.8);
    transition: all 0.3s ease;
    font-size 16px
    padding-top 80px

.articles.is-loading
  &:after
    content: "Loading...";
    text-align: center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0px;
    color: #000;
    height: 100%;
    background: rgba(255,255,255,0.8);
    transition: all 0.1s ease;
    font-size 16px

.ml-3
  margin-left 3px

.full-article
  text-align initial
  margin-top 15px
  &>>>h1
    font-size 35px
    line-height: 45px;
  &>>>h2
    font-weight 700
    font-size 21px
  &>>>h3
    font-weight 700
    font-size 19px
    
.sr-notice
  margin-top 20px

.support-suggestion
  textarea
    margin-top 10px
    margin-bottom 10px
    width 100%
    height 100px

.top-article-container
  margin-top 25px

.back
  text-align left
  font-size 13px
  a
    margin-left 5px

.contact-support
  font-size 14px

.features
  width 100%
.right-column
  position relative
  .right-column-container
    overflow-y: auto;
    position sticky
    width: 252px;

.mt-10
  margin-top: 10px !important

.continue-reading
  bottom 5px
  margin-top 2.5px

.social-network
  margin-bottom 10px
  div
    font-size 16px
    font-weight 400
  a
    font-size 12px
    display block
    font-weight 400
@media (max-width: 768px)
  .articles
    .article-mini
      margin-top 5px
      .article-title
        min-height initial
      .article-content
        min-height initial
  
  .features
    .right-column
      display: flex;
      justify-content: center;
      .right-column-container
        position initial
        text-align center
        width: 100%;
  
  .full-article >>> pre
    max-width: calc(100vw - 50px);
  
  .full-article >>> img
    max-width: calc(100vw - 50px);
  
  .full-article >>> blockquote
    overflow-wrap: anywhere;
  
  .full-article >>> ul
    max-width: calc(100vw - 50px);
    overflow: auto
    
  .full-article >>> a
    overflow-wrap: anywhere;
  
  .full-article >>> p
    overflow-wrap: anywhere;

html.dark, body.dark
  .category-container.is-loading
    &:after
      color #fff
      background #2c2c2c
  .articles.is-loading
    &:after
      color #fff
      background #2c2c2c
  .category
    background #2c2c2c
    a, span
      color: #fff;
  .articles
    a, span
      color: #fff;
    .article-mini
      .article-inner
        &:hover
          border solid 1px #fff
          
  .full-article
    &>>>
      color #fff
      &strong
        color #fff
</style>



// WEBPACK FOOTER //
// View_Support.vue?6cac6a92